/** Placeholder visual enquanto GET /api/v1/hub carrega. */
export function HubShellSkeleton() {
  return (
    <div className="bp-page" aria-busy="true" aria-live="polite">
      <span className="bp-sr-only">Carregando o hub…</span>
      <div className="bp-skel-header">
        <div className="bp-skel bp-skel--line bp-skel--w40" />
        <div className="bp-skel bp-skel--line bp-skel--title" />
        <div className="bp-skel bp-skel--line bp-skel--w60" />
      </div>
      <div className="bp-card bp-skel-card">
        <div className="bp-skel bp-skel--line bp-skel--w30" />
        <div className="bp-skel bp-skel--block" />
        <div className="bp-skel bp-skel--line" />
        <div className="bp-skel bp-skel--line bp-skel--w70" />
      </div>
      <div className="bp-skel-grid">
        <div className="bp-card bp-skel-card">
          <div className="bp-skel bp-skel--line bp-skel--w50" />
          <div className="bp-skel bp-skel--block bp-skel--block-sm" />
        </div>
        <div className="bp-card bp-skel-card">
          <div className="bp-skel bp-skel--line bp-skel--w50" />
          <div className="bp-skel bp-skel--block bp-skel--block-sm" />
        </div>
      </div>
      <div className="bp-card bp-skel-card">
        <div className="bp-skel bp-skel--line bp-skel--w40" />
        <div className="bp-skel bp-skel--btn" />
        <div className="bp-skel bp-skel--btn" />
      </div>
    </div>
  )
}
